import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockFaqs extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('BlockFaqs', ScrollItem__BlockFaqs);

export default ScrollItem__BlockFaqs;
